export function normalizeRepositorySelections(
  value: unknown,
): Record<string, string[]> | undefined {
  if (!value || typeof value !== "object" || Array.isArray(value))
    return undefined;
  return Object.fromEntries(
    Object.entries(value).map(([workspaceId, selected]) => {
      const ids = Array.isArray(selected)
        ? selected.filter((id): id is string => typeof id === "string")
        : typeof selected === "string"
          ? [selected]
          : [];
      return [workspaceId, [...new Set(ids)]];
    }),
  );
}

export function readStoredJson<T>(key: string, fallback: T): T {
  try {
    const value = JSON.parse(localStorage.getItem(key) ?? "null") as unknown;
    return value === null ? fallback : (value as T);
  } catch {
    return fallback;
  }
}
